<template>
    <div class="sr-tooltip">
        <div class="pa-5 pt-3 pb-0 sr-tooltip-title-wrapper brand-blue--text d-flex justify-space-between">
            <p class="pb-2">
                {{ title }}
            </p>
            <p>{{ value | formatNumber }} Fans</p>
        </div>
        <div class="sr-tooltip-item-container pa-5 pt-0 d-flex flex-column">
            <div
                v-for="item in items"
                :key="item.color"
                class="pt-3 d-flex sr-tooltip-item-wrapper justify-space-between align-center"
                :data-color="item.color"
            >
                <SrLabel :color="item.color" :text="item.label" />
                <span class="sr-tooltip-item-number"> {{ item.value | formatNumber }}</span>
            </div>
        </div>
        <div class="pointer">
            <div class="left top" />
            <div class="right top" />
            <div class="left bottom" />
            <div class="right bottom" />
        </div>
    </div>
</template>

<script>
import SrLabel from '../SrLabel/SrLabel';
import { formatNumber } from '../../filters';

export default {
    name: 'SrEngagementTooltip',
    components: { SrLabel },
    filters: {
        formatNumber,
    },
    props: {
        title: {
            type: String,
            default: 'Title',
        },
        value: {
            type: Number,
            default: 0,
        },
        items: {
            type: Array,
            default: () => [],
        },
    },
};
</script>
